import * as React from 'react';

// 開閉状態を管理するカスタムhooks
export default function useDialog() {
  const [open, setOpen] = React.useState(false);

  // openの状態を変更する
  const onOpenChange = (open: boolean) => {
    // 開いた場合
    if (open) {
      // スクロールを禁止する
      document.body.style.position = 'fixed';
      // 画面幅が変わらないようスクロールバーは表示する
      document.documentElement.style.overflowY = 'scroll';
      document.body.style.overflowY = 'hidden';
    }
    // 閉じた場合
    else {
      // スクロールを許可する
      document.body.style.position = 'static';
      // スクロールバーは各ページのコンテンツに合わせて表示する
      document.documentElement.style.overflowY = 'visible';
      document.body.style.overflowY = 'visible';
    }
    setOpen(open);
  };

  // 開閉状態と切り替える関数を返す
  return { open, onOpenChange };
}
